const collapseWhitespace = (value) => String(value ?? "").replace(/\s+/g, " ").trim();

export const cleanAutocompleteText = (value) => collapseWhitespace(value);

export const normalizeAutocompleteText = (value) => collapseWhitespace(value).toLowerCase();

export const getAutocompleteOptionLabel = (option) => {
  if (typeof option === "string") return cleanAutocompleteText(option);
  if (!option || typeof option !== "object") return cleanAutocompleteText(option);

  return cleanAutocompleteText(
    option.inputValue ?? option.name ?? option.label ?? option.title ?? option.value ?? ""
  );
};

export const dedupeAutocompleteStrings = (values = []) => {
  const seen = new Set();
  const next = [];

  (Array.isArray(values) ? values : []).forEach((value) => {
    const label = cleanAutocompleteText(value);
    const key = normalizeAutocompleteText(label);
    if (!label || seen.has(key)) return;
    seen.add(key);
    next.push(label);
  });

  return next;
};

export const dedupeAutocompleteOptions = (options = [], getLabel = getAutocompleteOptionLabel) => {
  const seen = new Set();
  const next = [];

  (Array.isArray(options) ? options : []).forEach((option) => {
    const label = cleanAutocompleteText(getLabel(option));
    const key = normalizeAutocompleteText(label);
    if (!label || seen.has(key)) return;
    seen.add(key);
    next.push(option);
  });

  return next;
};